import { all, takeLatest, call } from 'redux-saga/effects';
import { getUrlFormatter, replaceLocation, pushLocation } from '@grandvisionhq/state';
import { GOTO, INIT } from './actions.js';
import { init } from './auth.js';
import createAccountSagas from './CreateAccount/sagas.js';
import loginSagas from './Login/sagas.js';
import logoutSagas from './Logout/sagas.js';
import optInSagas from './OptIns/sagas.js';
import resetPasswordSagas from './ResetPassword/sagas.js';
import userDataSagas from './UserData/sagas.js';
import { redirect } from './Util/redirect.js';

function* authInit(action) {
    const { domain , customDomain , clientId , basePath  } = action.payload;
    yield call(init, {
        clientID: clientId,
        domain: customDomain || domain,
        audience: 'fake_https://api.local:3080/',
        redirectUri: `${window.location.protocol}//${window.location.host}/${basePath}/callback`
    });
}
function* onGoto(action) {
    if ('path' in action.payload) {
        const pathname = `/${action.payload.path}`.replace('//', '/');
        yield call(redirect, pathname);
        return;
    }
    const formatter = yield call(getUrlFormatter);
    const requestedRoute = formatter({
        route: action.payload.route
    });
    if (!requestedRoute) {
        throw new Error(`Tried to go to optional route '${action.payload.route}' but it is not set. Formatted routes contained: '${String(requestedRoute)}'`);
    }
    /**
   * Sometimes we need to do a full page refresh, e.g. in case of logging out.
   */ if (action.payload.fullPageRefresh) {
        const resolvedRoute = `${window.location.protocol}//${window.location.host}${requestedRoute}`;
        const path = action.payload.query ? `${resolvedRoute}?${action.payload.query}` : `${resolvedRoute}`;
        yield call(replaceLocation, new URL(path));
        return;
    }
    const baseRoute = `${window.location.protocol}/${window.location.host}${requestedRoute}`;
    const query = action.payload.query ? `?${action.payload.query}` : '';
    yield call(pushLocation, new URL(`${baseRoute}${query}`));
}
function* sagas() {
    yield all([
        ...createAccountSagas,
        ...loginSagas,
        ...logoutSagas,
        ...resetPasswordSagas,
        ...optInSagas,
        ...userDataSagas,
        takeLatest(GOTO, onGoto),
        takeLatest(INIT, authInit), 
    ]);
}

export { authInit, sagas as default, onGoto };
//# sourceMappingURL=sagas.js.map
